import Http from '@/services/httpAcademy'

export const listBookings = (params) =>
	Http.get('/admin/bookings', { params })

export const getBooking = (id) =>
	Http.get(`/admin/bookings/${id}`)
